import { css } from '@emotion/react'

const moreOptions = css`
  @media only screen and (max-height: 600px) {
    overflow: auto;
  }
`

export const styles = {
  moreOptions,
}
